import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectEmployeesAssignmentEnum } from 'generated/resources/graphql'

import RadioInput from 'modules/core/components/Inputs/FilterSelect/SelectOption/RadioInput'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface IEmployeeAssignmentSelectorProps {
  includeInactive?: boolean
  isManualSelected: boolean
  onSelectEmployees: (newEmployees: EmployeeSelectorV2MultiSelectState) => void
  initialEmployeeIds: number[]
  toggleAssignmentSelection: (value: ProjectManagementProjectEmployeesAssignmentEnum) => void
}

const EmployeeAssignmentSelector = ({
  includeInactive = false,
  isManualSelected,
  onSelectEmployees,
  initialEmployeeIds,
  toggleAssignmentSelection,
}: IEmployeeAssignmentSelectorProps) => {
  return (
    <Box gap="s16">
      <Box
        gap="s16"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: !isManualSelected ? 'viridian1000' : 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
      >
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal weight="semibold">
            {i18n.t('project_management.modals.assign_employees.options.company.title')}
          </Text.Normal>
          <Touchable
            onClick={() => toggleAssignmentSelection('company')}
            autofocus={!isManualSelected}
          >
            <RadioInput selected={!isManualSelected} />
          </Touchable>
        </Box>
        <Text.Normal>
          {i18n.t('project_management.modals.assign_employees.options.company.description')}
        </Text.Normal>
      </Box>
      <Box
        background="grey100"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Box
          gap="s16"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: isManualSelected ? 'viridian1000' : 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          padding="s16"
          width="fit-content"
          background="grey000White"
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="semibold">
              {i18n.t('project_management.modals.assign_employees.options.manual.title')}
            </Text.Normal>
            <Touchable
              onClick={() => toggleAssignmentSelection('manual')}
              autofocus={isManualSelected}
            >
              <RadioInput selected={isManualSelected} />
            </Touchable>
          </Box>
          <Text.Normal>
            {i18n.t('project_management.modals.assign_employees.options.manual.description')}
          </Text.Normal>
        </Box>
        {isManualSelected && (
          <Box padding="s16">
            <EmployeeSelectorV2
              multiple
              options={{ asList: true, disableSelectAll: true }}
              value={initialEmployeeIds}
              onChange={onSelectEmployees}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default EmployeeAssignmentSelector
